module.exports = __webpack_public_path__ + "img/Boucherie_2.8d89c090.jpg";